
export const OzetAnalizleriNav = [
    {
        icon: 'pe-7s-graph2',
        label: 'Özet Analizleri',
        to: '/dashboards/crm',
    },
    {
        icon: 'pe-7s-news-paper',
        label: 'Müşteri İş Raporu',
        to: '/dashboards/musteri-is-raporu',
    },
    {
        icon: 'pe-7s-clock',
        label: 'Süresi Dolan Lastikler',
        to: '/dashboards/suresi-dolan-lastikler-raporu',
    },
    {
        icon: 'pe-7s-chat',
        label: 'SMS Rapor',
        to: '/dashboards/sms-rapor',
    },
];

export const IsEmirleriNav = [
    {
        icon: 'pe-7s-note2',
        label: 'İş Emirleri',
        to: '/is-emirleri/is-emirleri',
    },
];

export const CarNav = [
    {
        icon: 'pe-7s-mail',
        label: 'Toplu SMS',
        to: '/arac-islemleri/toplu-sms',
    },
    {
        icon: 'pe-7s-car',
        label: 'Araç Listesi',
        to: '/arac-islemleri/arac-listesi',
    },
];

export const SuperAdminNav = [
    {
        icon: 'pe-7s-settings',
        label: 'Tenant Yönetimi',
        to: '/super-admin/tenantlar',
    },
    {
        icon: 'pe-7s-cash',
        label: 'Abonelikler',
        to: '/super-admin/abonelikler',
    },
    {
        icon: 'pe-7s-graph1',
        label: 'Abonelik Raporu',
        to: '/super-admin/abonelik-raporu',
    },
    {
        icon: 'pe-7s-box2',
        label: 'Paket Yönetimi',
        to: '/super-admin/abonelik-paketleri',
    },
];

export const LastikDepoNav = [
    {
        icon: 'pe-7s-box1',
        label: 'Depo İşlemleri',
        to: '/lastik-depo/depo-islemleri',
    },
    {
        icon: 'pe-7s-clock',
        label: 'Lastik Geçmişi',
        to: '/lastik-depo/lastik-gecmisi',
    },
];

export const UrunHizmetNav = [
    {
        icon: 'pe-7s-box2',
        label: 'Ürün & Hizmetler',
        to: '/urun-hizmet/liste',
    },
];

export const AracHareketleriNav = [
    {
        icon: 'pe-7s-refresh-2',
        label: 'Araç Hareketleri',
        to: '/arac-hareketleri/liste',
    },
];

export const TanimlarNav = [
    {
        icon: 'pe-7s-config',
        label: 'Tanımlar',
        to: '/tanimlar/liste',
    },
];

export const SmsSablonlariNav = [
    {
        icon: 'pe-7s-chat',
        label: 'SMS Şablonları',
        to: '/sms-sablonlari/liste',
    },
];

export const OneriNav = [
    {
        icon: 'pe-7s-comment',
        label: 'Müşteri Önerileri',
        to: '/oneriler/liste',
    },
];
